import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const isToolViewerRoute = location.pathname.startsWith('/ferramentas/');

  return (
    <div className="h-screen flex overflow-hidden bg-light-50 dark:bg-graphite-900">
      <Sidebar
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          isSidebarCollapsed={sidebarCollapsed}
          onToggleSidebarCollapse={() => setSidebarCollapsed(prev => !prev)}
        />

        <main className="flex-1 overflow-y-auto">
          <div className={isToolViewerRoute ? 'px-1 lg:px-1 py-1' : 'p-3 lg:p-3'}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
